<template>
  <div class="questionnaire-editor">
    <!-- 封面设置区域 -->
    <div class="cover-container">
      <div class="cover-switch-section">
        <span class="switch-label">
          使用{{
            dataObj.questionnaireType === "1"
              ? "问卷"
              : dataObj.questionnaireType === "2"
              ? "考试"
              : "测评"
          }}封面图
        </span>
        <el-switch
          v-model="dataObj.ifCover"
          active-color="#59D27B"
          active-value="1"
          inactive-value="0"
          size="medium"
        ></el-switch>
      </div>
      <div
        v-if="dataObj.ifCover === '1' && dataObj.coverUrl"
        class="cover-image-container"
      >
        <img
          v-if="mediaType === 'image'"
          :src="dataObj.coverUrl"
          class="cover-image"
          alt="封面图"
        />
        <video
          v-else
          :src="dataObj.coverUrl"
          class="cover-video"
          controls
        ></video>
        <el-button class="change-cover-btn" @click="handleChooseCover"
          >封面设置</el-button
        >
      </div>
    </div>

    <!-- 标题和描述区域 -->
    <div class="container">
      <div
        class="input-container"
        :style="{
          border: isFocus
            ? '1px solid rgba(58,96,255,0.5)'
            : '1px solid #DCDDE0',
        }"
      >
        <input
          v-model="dataObj.questionnaireName"
          :placeholder="
            (dataObj.questionnaireType === '1'
              ? '问卷'
              : dataObj.questionnaireType === '2'
              ? '考试'
              : '测评') + '标题'
          "
          class="input-content"
          @focus="isFocus = true"
          @blur="isFocus = false"
        />
      </div>

      <div class="other-view">
        <!-- 描述输入框 -->
        <div
          class="region"
          :style="{
            border: textareaFocus
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
          }"
        >
          <textarea
            v-model="dataObj.questionnaireDescribe"
            placeholder="感谢您抽出宝贵时间，您的回答意义重大！"
            class="textarea-content"
            @focus="textareaFocus = true"
            @blur="textareaFocus = false"
          ></textarea>
        </div>

        <!-- 选择位置，实现代码 -->
        <div style="display: flex; flex-wrap: wrap">
          <div
            v-for="(item, index) in moduleTypes"
            :key="'a' + index"
            class="topic-item"
            @click.stop="moduleItemClick(item)"
          >
            <img
              :src="item.url"
              :style="{ width: item.width }"
              mode="widthFix"
              alt="模块图标"
            />
            <span class="topic-item-title">{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 模块列表 -->
    <div
      v-for="(item, index) in moduleList"
      :key="index"
      class="module-item-container"
    >
      <div class="module-header">
        <div class="module-input">
          <input
            v-model="item.moduleContent.context"
            placeholder="自定义段落标题"
            class="module-input-content"
            @input="handleInputTitle($event, index)"
          />
          <img
            v-if="item.moduleContent.context"
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="clear-btn1"
            @click.stop="clearModuleInput(index)"
            alt="清空"
          />
        </div>
        <div class="operate-view">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737459811261.png"
            class="operate-view-img"
            @click.stop="handleOperate(0, index)"
            alt="上移"
          />
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737459843491.png"
            class="operate-view-img"
            @click.stop="handleOperate(1, index)"
            alt="下移"
          />
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737459860295.png"
            class="operate-view-img"
            @click.stop="handleOperate(2, index)"
            alt="删除"
          />
        </div>
      </div>

      <!-- 大图模块 -->
      <div v-if="item.moduleType === 1" class="module-item1">
        <div
          v-for="(imgItem, imgIndex) in item.moduleContent.urls"
          :key="imgIndex"
          class="image-view"
        >
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="del"
            @click.stop="handleDeleteChildItem(index, imgIndex)"
            alt="删除"
          />
          <img :src="imgItem.url" class="img" alt="大图" />
        </div>
        <div
          v-if="item.moduleContent.urls.length < 9"
          class="add-url"
          @click="handleSingleImage(index)"
        >
          <div class="plus-icon"></div>
          <span class="plus-text">点击上传图片</span>
        </div>
      </div>

      <!-- 小图（九宫格）模块 -->
      <div v-if="item.moduleType === 2" class="module-item2">
        <div class="image-list">
          <div
            v-for="(imgItem, imgIndex) in item.moduleContent.urls"
            :key="imgIndex"
            class="small-img-item"
          >
            <img
              @click="showBigImage(imgItem.url)"
              :src="imgItem.url"
              class="small-img"
              alt="小图"
            />
            <img
              src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
              class="small-img-del"
              @click.stop="handleDeleteChildItem(index, imgIndex)"
              alt="删除"
            />
          </div>
          <div
            v-if="item.moduleContent.urls.length < 9"
            class="upload-small"
            @click="handleMutipleImage(index)"
          >
            <div class="plus-icon-gray"></div>
            <span>点击上传图片</span>
          </div>
        </div>
      </div>

      <!-- 位置模块 -->
      <div v-if="item.moduleType === 3" class="module-item3">
        <!-- 有地址时显示地图 -->
        <div
          v-if="item.moduleContent.address !== ''"
          style="position: relative"
          class="map-container"
        >
          <div style="position: relative">
            <BaiduMapViewer
              :lng-lat="[
                item.moduleContent.longitude,
                item.moduleContent.latitude,
              ]"
              :ak="baiduMapAk"
              marker-title="所在位置"
              map-height="380px"
            />
            <div
              style="
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 10;
                top: 0;
                left: 0;
                opacity: 0;
                cursor: pointer;
              "
              @click="chooseLocation(index)"
            ></div>
          </div>
          <div style="width: 100%; text-align: left; margin-top: 10px">
            {{ item.moduleContent.address }}{{ item.moduleContent.name }}
          </div>
          <!-- 遮罩层（保持原点击触发选择地址的逻辑） -->
          <div class="map-mask" @click="chooseLocation(index)"></div>
        </div>
        <!-- 无地址时显示添加按钮 -->
        <div v-else class="add-url" @click="chooseLocation(index)">
          <div class="plus-icon"></div>
          <span class="plus-text">点击添加地址</span>
        </div>
      </div>

      <!-- 文件模块 -->
      <div v-if="item.moduleType === 4" class="module-item3">
        <div
          v-for="(fileItem, fileIndex) in item.moduleContent.files"
          :key="fileIndex"
          class="file-item"
        >
          <img :src="getFileIcon(fileItem)" class="img" alt="文件图标" />
          <div class="file-info">
            <span class="file-name">{{ fileItem.name }}</span>
          </div>
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="del"
            @click.stop="handleDeleteChildFile(index, fileIndex)"
            alt="删除"
          />
        </div>
        <div
          v-if="item.moduleContent.files.length < 5"
          class="add-url"
          @click="handleChooseFile(index)"
        >
          <div class="plus-icon"></div>
          <span class="plus-text">点击添加文件</span>
        </div>
      </div>

      <!-- 音频模块 -->
      <div v-if="item.moduleType === 5" class="module-item3">
        <div
          v-for="(audioItem, audioIndex) in item.moduleContent.audios"
          :key="audioIndex"
          class="music-view"
          @click="handleAudioPlay(index, audioIndex)"
        >
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/music-1769330643047.png"
            class="music-image"
            alt="音频"
          />
          <div class="music-time">{{ secondsToHms(audioItem.time) }}</div>
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="del"
            @click.stop="handleDeleteChildAudio(index, audioIndex)"
            alt="删除"
          />
        </div>
        <div
          v-if="item.moduleContent.audios.length < 5"
          class="add-url"
          @click="handleChooseAudio(index)"
        >
          <div class="plus-icon"></div>
          <span class="plus-text">点击上传音频</span>
        </div>
      </div>

      <div v-if="item.moduleType === 6" class="module-item3">
        <div
          v-for="(videoItem, videoIndex) in item.moduleContent.urls"
          :key="videoIndex"
          class="video-view"
        >
          <!-- <video
                :src="videoItem.url"
                style="width: 100%; height: 200px"
              ></video> -->
          <video :src="videoItem.url" controls></video>
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="del"
            @click.stop="handleDeleteChildItem(index, videoIndex)"
            alt="删除"
          />
        </div>
        <div
          v-if="item.moduleContent.urls < 1"
          class="add-url"
          @click="handleChooseVideo(index)"
        >
          <div class="plus-icon"></div>
          <div class="plus-text">点击上传视频</div>
        </div>
      </div>

      <!-- 其他模块（公众号、视频号、关联问卷等）简化保留结构 -->
      <div v-if="item.moduleType === 7" class="module-item4">
        <div class="module-input-view">
          <span class="module-input-label">标题</span>
          <div class="module-input-field">
            <input
              v-model="item.moduleContent.title"
              placeholder="请输入标题"
              class="module-input-content"
            />
          </div>
        </div>
        <div class="module-input-view">
          <span class="module-input-label">公众号文章链接</span>
          <div class="module-input-field">
            <input
              v-model="item.moduleContent.link"
              placeholder="请输入公众号文章链接"
              class="module-input-content"
            />
          </div>
        </div>

        <div class="demonstrate-view">
          <span>公众号必须关联到问卷加加小程序才能生效</span>
          <div class="demonstrate" @click="handleShowOfficialAccount">
            演示
            <div class="setting-icon"></div>
          </div>
        </div>
      </div>

      <!-- 视频号信息录入模块（moduleType=8） -->
      <div v-if="item.moduleType === 8" class="module-item4">
        <!-- 标题输入项 -->
        <div class="module-input-view">
          <span class="module-input-label">标题</span>
          <div class="module-input-field">
            <input
              class="form-input"
              :class="{ 'input-placeholder': !item.moduleContent.title }"
              v-model="item.moduleContent.title"
              placeholder="请输入视频号标题"
              style="width: 100%; border: none"
            />
          </div>
        </div>

        <!-- 视频号ID输入项 -->
        <div class="module-input-view">
          <span class="module-input-label">视频号 ID</span>
          <div class="module-input-field">
            <input
              class="form-input"
              :class="{
                'input-placeholder': !item.moduleContent.channelId,
              }"
              v-model="item.moduleContent.channelId"
              placeholder="请输入以sph开头的视频号 ID"
              style="width: 100%; border: none"
            />
          </div>
        </div>

        <!-- 视频ID输入项 -->
        <div class="module-input-view">
          <span class="module-input-label">视频 ID</span>
          <div class="module-input-field">
            <input
              class="form-input"
              :class="{ 'input-placeholder': !item.moduleContent.videoId }"
              v-model="item.moduleContent.videoId"
              placeholder="请输入视频 ID"
              style="width: 100%; border: none"
            />
          </div>
        </div>

        <!-- 演示说明项 -->
        <div class="demonstrate-view">
          <span>如何获取视频号 ID和视频 ID？</span>
          <div class="demonstrate" @click="handleShowVideoDemo">
            演示
            <div class="setting-icon"></div>
          </div>
        </div>
      </div>

      <div v-if="item.moduleType === 9" class="module-item3">
        <div
          v-for="(subItem, subIndex) in item.moduleContent.list"
          :key="subIndex"
          class="module-input-view"
        >
          <div
            class="module-input-field"
            style="justify-content: space-between"
          >
            <span class="question-name">{{ subItem.name }}</span>
            <div class="arrow-icon"></div>
          </div>
          <img
            src="https://ossfastmake.mustke.com/wenjuan/tupian/关闭(1)-1770804336222.svg"
            class="del"
            @click.stop="handleDeleteQuestion(index, subIndex)"
            alt="删除"
          />
        </div>
        <div
          v-if="item.moduleContent.list.length < 5"
          class="add-url"
          @click="handleAddQuestionnaire(index)"
        >
          <div class="plus-icon"></div>
          <span class="plus-text">点击关联问卷/考试/测评</span>
        </div>
      </div>

      <!-- 小程序信息录入模块（moduleType=10） -->
      <div v-if="item.moduleType === 10" class="module-item4">
        <!-- 标题输入项 -->
        <div class="module-input-view">
          <span class="module-input-label">标题</span>
          <div class="module-input-field">
            <input
              class="form-input"
              :class="{ 'input-placeholder': !item.moduleContent.title }"
              v-model="item.moduleContent.title"
              placeholder="请输入小程序展示标题"
              style="width: 100%; border: none"
            />
          </div>
        </div>

        <!-- 小程序APP ID输入项 -->
        <div class="module-input-view">
          <span class="module-input-label">小程序APP ID</span>
          <div class="module-input-field">
            <input
              class="form-input"
              :class="{ 'input-placeholder': !item.moduleContent.appId }"
              v-model="item.moduleContent.appId"
              placeholder="请输入小程序APP ID"
              style="width: 100%; border: none"
            />
          </div>
        </div>

        <!-- 小程序页面路径输入项 -->
        <div class="module-input-view">
          <span class="module-input-label">小程序页面路径</span>
          <div class="module-input-field">
            <input
              class="form-input"
              :class="{ 'input-placeholder': !item.moduleContent.pagePath }"
              v-model="item.moduleContent.pagePath"
              placeholder="请输入小程序页面路径"
              style="width: 100%; border: none"
            />
          </div>
        </div>

        <!-- 演示说明项 -->
        <div class="demonstrate-view">
          <span>如何获取小程序APP ID和小程序页面路径？</span>
          <div class="demonstrate" @click="handleShowMiniProgramDemo">
            演示
            <div class="setting-icon"></div>
          </div>
        </div>
      </div>

      <!-- 复制内容模块（moduleType=11） -->
      <div v-if="item.moduleType === 11" class="module-item5">
        <div class="module-input-view">
          <div class="module-input-field copy-field">
            <input
              class="form-input"
              :class="{
                'input-placeholder': !item.moduleContent.copyContext,
              }"
              v-model="item.moduleContent.copyContext"
              placeholder="请输入需要被复制的内容"
              style="width: 100%; border: none"
            />
            <div
              class="copy"
              @click="copyContent(item.moduleContent.copyContext)"
            >
              复制
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog
      title="图片预览"
      :visible.sync="fangdaShow"
      width="80%"
      :close-on-click-modal="false"
    >
      <img :src="fangdaImgUrl" style="width: 100%" alt="预览图" />
    </el-dialog>

    <!-- 隐藏的文件上传input -->
    <input
      ref="fileInput"
      type="file"
      style="display: none"
      :accept="fileAccept"
      :multiple="fileMultiple"
      @change="handleFileChange"
    />

    <div class="coverShow" v-show="showRelational">
      <div class="container-gj" @click="showRelational = false">
        <div class="container-gd" @click.stop>
          <div
            class=""
            style="
              width: 100%;
              border-bottom: 1px solid #e7e7e7;
              height: 58px;
              text-align: center;
              line-height: 58px;
              color: #2b2f36;
              font-size: 18px;
              font-weight: 600;
            "
          >
            关联问卷
          </div>
          <div class="search-section">
            <div class="search-input-wrapper">
              <i class="el-icon-search" size="20" style="color: #8e89aa"></i>
              <input
                type="text"
                v-model="searchKeywords"
                placeholder="请搜索问卷/考试/评测名称"
                class="search-input"
                placeholder-class="input-placeholder"
              />
              <div class="search-btn" @click.stop="handleSearch">
                <i class="el-icon-search" size="20" style="color: #ffffff"></i>
              </div>
            </div>
          </div>
          <div class="relational-container">
            <el-table
              ref="multipleTable"
              :data="relationalList"
              border
              :show-header="false"
              :cell-style="{ background: '#ffffff' }"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
                :selectable="handleSelectable"
              >
              </el-table-column>
              <el-table-column label="问卷名称">
                <template slot-scope="scope">{{
                  scope.row.questionnaireName
                }}</template>
              </el-table-column>
            </el-table>
          </div>
          <div style="text-align: right; margin-bottom: 15px">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
          <div class="popup-button" @click="handleSureLink">确认关联</div>
        </div>
      </div>
    </div>
    <SetCoverImage
      :showDialog="showCoverImage"
      :param="{
        coverUrl: dataObj.coverUrl,
        ifSyncCoverToShare: dataObj.ifSyncCoverToShare,
        questionnaireType: dataObj.questionnaireType,
        uuid: uuid,
      }"
      @setCoverImage="setCoverImageComplete"
      @close="showCoverImage = false"
    ></SetCoverImage>
    <!-- <div>
      <el-input
        v-model="address.name"
        placeholder="请选择位置"
        readonly
        @click.native="showMap = true"
      >
        <template slot="append">
          <el-button icon="el-icon-location" @click="showMap = true"
            >选择</el-button
          >
        </template>
      </el-input>

      <div v-if="address.lat" class="address-detail">
        <i class="el-icon-location-outline"></i>
        {{ address.address }}（{{ address.lat }}, {{ address.lng }}）
      </div>

      <BaiduMapPicker
        :show="showMap"
        @close="showMap = false"
        @select="handleSelect"
      />
    </div> -->

    <BaiduMapPicker
      :show="showMap"
      @close="showMap = false"
      @select="handleSelectLocation"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import {
  userList,
  getCoverCategoryList,
  getCoverImageList,
} from "@/api/index.js";
import SetCoverImage from "@/components/SetCoverImage/index.vue";
import BaiduMapPicker from "@/components/BaiduMapPicker/BaiduMapPicker.vue";
import BaiduMapViewer from "@/components/BaiduMapViewer/index.vue";
BaiduMapViewer;
export default {
  name: "QuestionnaireEditor",
  components: {
    // VueCropper,
    SetCoverImage,
    BaiduMapPicker,
    BaiduMapViewer,
  },
  props: {
    dataObj: {
      type: Object,
      default: () => ({}),
    },
    modules: {
      type: Array,
      default: () => [],
    },
    uuid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isFocus: false,
      textareaFocus: false,
      showPicker: false,
      fileType: "",
      list: [],
      selectIndex: 0,
      moduleTypes: [
        {
          text: "大图",
          desc: "显示整张大图",
          type: 1,
          url: require("@/assets/images/add_modules/module01.svg"),
          width: "24px",
        },
        {
          text: "小图",
          desc: "九宫格样式图片",
          type: 2,
          url: require("@/assets/images/add_modules/module02.svg"),
          width: "23px",
        },
        {
          text: "位置",
          desc: "添加位置信息",
          type: 3,
          url: require("@/assets/images/add_modules/module03.svg"),
          width: "24px",
        },
        {
          text: "文件",
          desc: "大小10MB内",
          type: 4,
          url: require("@/assets/images/add_modules/module04.svg"),
          width: "22px",
        },
        {
          text: "音频",
          desc: "大小20MB内",
          type: 5,
          url: require("@/assets/images/add_modules/module05.svg"),
          width: "23px",
        },
        {
          text: "视频",
          desc: "大小200MB内",
          type: 6,
          url: require("@/assets/images/add_modules/module06.svg"),
          width: "22px",
        },
        {
          text: "公众号",
          desc: "跳转公众号文章",
          type: 7,
          url: require("@/assets/images/add_modules/module07.svg"),
          width: "22px",
        },
        {
          text: "视频号",
          desc: "关联视频号",
          type: 8,
          url: require("@/assets/images/add_modules/module08.svg"),
          width: "22px",
        },
        {
          text: "关联问卷",
          desc: "关联已创建问卷",
          type: 9,
          url: require("@/assets/images/add_modules/module09.svg"),
          width: "22px",
        },
        {
          text: "关联小程序",
          desc: "跳转其他小程序",
          type: 10,
          url: require("@/assets/images/add_modules/module10.svg"),
          width: "20px",
          height: "20px",
        },
        {
          text: "复制区",
          desc: "复制文本链接等内容",
          type: 11,
          url: require("@/assets/images/add_modules/module11.svg"),
          width: "22px",
          height: "23px",
        },
      ],
      moduleList: [],
      kspImgWidth: 350,
      kspImgHeight: 560,
      tempFilePath: "",
      showRelational: false,
      relationalList: [],
      mediaType: "image",
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      // 文件上传相关
      fileAccept: "",
      fileMultiple: false,
      audioContext: null, // 音频上下文
      currentAudio: null, // 用于追踪当前播放的音频
      searchKeywords: "",
      map: null,
      marker: null,
      mapMarker: null,
      showCoverImage: false,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      showMapSelector: false, // 控制弹窗显示
      mapKey: "CWJBZ-4F6RW-5OPR5-3SS65-NXMKF-6KBR3", // 替换为自己的Key
      baiduMapAk: "JTHkbx0S6LPyftMVJafqLMUTPj3bsAI6", // 替换为自己的AK
      selectedLocation: {
        // 存储选点结果
        address: "",
        lng: "",
        lat: "",
      },
      showMap: false,
      address: { name: "", address: "", lat: null, lng: null },
    };
  },
  watch: {
    dataObj: {
      handler(newValue) {
        this.list = newValue.questionnaireInformation
          ? JSON.parse(newValue.questionnaireInformation)
          : [];
        // 不直接修改prop，而是通过计算或使用本地变量
        if (!newValue.questionnaireDescribe) {
          // 使用$set来修改对象属性（如果需要）
          this.$set(newValue, "questionnaireDescribe", "");
        }

        // 判断封面类型（图片/视频）
        if (newValue.coverUrl) {
          const type = newValue.coverUrl.split("?")[0].split(".").pop();
          this.mediaType = ["mp4", "avi", "mov"].includes(type)
            ? "video"
            : "image";
        }
      },
      deep: true,
      immediate: true,
    },
    modules: {
      handler(newValue) {
        // 确保moduleList始终是数组
        this.moduleList = newValue || [];
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // 创建音频上下文
    this.audioContext = new Audio();
    this.getRelationalList();

    console.log(
      "j4ruh2uirg22ft23riurg23irg23iur23r3",
      this.dataObj.questionnaireType,
    );

    getCoverCategoryList({
      activityType: this.dataObj.questionnaireType,
    })
      .then((res) => {
        console.log(res, "封面分类列表");
        getCoverImageList({
          categoryId: res.data[0].id,
          keywords: "",
        })
          .then((res) => {
            console.log(res, "封面图片列表");
            if (
              this.dataObj.coverUrl === "" ||
              this.dataObj.coverUrl === null ||
              this.dataObj.coverUrl === undefined
            ) {
              this.dataObj.coverUrl = res.rows[0].coverUrl;
              this.mediaType = "image";
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err, "封面图片列表失败");
          });
      })
      .catch((err) => {
        console.log(err, "封面分类列表失败");
      });
  },
  beforeDestroy() {
    // 销毁音频上下文
    if (this.audioContext) {
      this.audioContext.pause();
      this.audioContext = null;
    }
  },
  methods: {
    handleSelectLocation(location) {
      // this.address[this.selectIndex] = location;
      this.moduleList[this.selectIndex].moduleContent.latitude = location.lat;
      this.moduleList[this.selectIndex].moduleContent.longitude = location.lng;
      this.moduleList[this.selectIndex].moduleContent.address =
        location.address;
      this.moduleList[this.selectIndex].moduleContent.name = location.name;
      console.log("选中位置:", location);
    },
    getRelationalList() {
      userList({
        releaseStatus: "",
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        questionnaireName: this.searchKeywords,
        questionnaireType: "",
      })
        .then((response) => {
          console.log(response, "fk293r9302r2309ry2309ry230r2309r230r32");

          this.relationalList = response.rows;
          this.total = response.total;
        })
        .catch((err) => {
          console.log("err", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选中行变化事件（原有逻辑保留）
    handleSelectionChange(val) {
      this.selectedRows = val;
      console.log("选中的行：", val);
    },
    // 模块点击事件
    moduleItemClick(item) {
      switch (item.type) {
        case 1:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "大图",
              urls: [],
            },
          });
          break;
        case 2:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "小图",
              urls: [],
            },
          });
          break;
        case 3:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "位置",
              latitude: "",
              longitude: "",
              address: "",
              name: "",
            },
          });
          break;
        case 4:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "文件",
              files: [],
            },
          });
          break;
        case 5:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "音频",
              audios: [],
            },
          });
          break;
        case 6:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "视频",
              urls: [],
            },
          });
          break;
        case 7:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "公众号",
              title: "", // 公众号文章标题
              link: "", // 公众号文章链接
            },
          });
          break;
        case 8:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "视频号",
              title: "", // 视频号标题
              channelId: "", // 以sph开头的视频号 ID
              videoId: "", // 视频号 ID
            },
          });
          break;
        case 9:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "关联问卷",
              list: [],
            },
          });
          break;
        case 10:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "关联小程序",
              title: "", // 小程序展示标题
              appId: "", // 小程序APP ID
              pagePath: "", // 小程序页面路径
            },
          });
          break;
        case 11:
          this.moduleList.push({
            moduleType: item.type,
            moduleContent: {
              context: "复制区",
              copyContext: "", // 复制内容
            },
          });
          break;
        default:
          break;
      }
      console.log(this.moduleList);
    },
    // 模块操作（上移/下移/删除）
    handleOperate(type, index) {
      switch (type) {
        case 0: // 上移
          this.moveItemUp(index);
          break;
        case 1: // 下移
          this.moveItemDown(index);
          break;
        case 2: // 删除
          // 判断如果是当前播放的音频，直接停止播放
          if (this.currentAudio && this.currentAudio.index === index) {
            if (!this.audioContext.paused) {
              this.audioContext.pause();
            }
            this.currentAudio = null;
          }
          this.moduleList.splice(index, 1);
          break;
      }
    },
    // 上移模块
    moveItemUp(index) {
      if (index === 0) {
        this.$message.warning("已经是第一项");
        return;
      }
      const temp = this.moduleList[index - 1];
      this.moduleList.splice(index - 1, 1, this.moduleList[index]);
      this.moduleList.splice(index, 1, temp);
    },
    // 下移模块
    moveItemDown(index) {
      if (index === this.moduleList.length - 1) {
        this.$message.warning("已经是最后一项");
        return;
      }
      const temp = this.moduleList[index + 1];
      this.moduleList.splice(index + 1, 1, this.moduleList[index]);
      this.moduleList.splice(index, 1, temp);
    },
    // 选择单张图片
    handleSingleImage(index) {
      this.fileType = "单张图片";
      this.selectIndex = index;
      this.fileAccept = "image/*";
      this.fileMultiple = false;
      setTimeout(() => {
        this.$refs.fileInput.click();
      }, 100);
    },
    // 选择多张图片
    handleMutipleImage(index) {
      this.fileType = "多张图片";
      this.selectIndex = index;
      this.fileAccept = "image/*";
      this.fileMultiple = true;
      setTimeout(() => {
        this.$refs.fileInput.click();
      }, 100);
    },
    // 选择文件
    handleChooseFile(index) {
      this.fileType = "文件";
      this.selectIndex = index;
      this.fileAccept = ".doc,.docx,.xls,.xlsx,.pdf,.zip";
      this.fileMultiple = false;
      setTimeout(() => {
        this.$refs.fileInput.click();
      }, 100);
    },
    // 选择音频
    handleChooseAudio(index) {
      this.fileType = "音频";
      this.selectIndex = index;
      this.fileAccept = ".mp3,.wav,.amr,.m4a";
      this.fileMultiple = false;
      setTimeout(() => {
        this.$refs.fileInput.click();
      }, 100);
    },
    handleChooseVideo(index) {
      this.fileType = "视频";
      this.selectIndex = index;
      this.fileAccept = ".mp4,.avi,.mov,.wmv";
      this.fileMultiple = false;
      setTimeout(() => {
        this.$refs.fileInput.click();
      }, 100);
    },
    // 文件选择回调
    handleFileChange(e) {
      console.log("files11111111111111", e);
      const files = e.target.files;
      if (!files.length) return;

      // 根据文件类型处理
      if (this.fileType.includes("图片")) {
        this.handleImageUpload(files);
      } else if (this.fileType === "文件") {
        this.handleFileUpload(files);
      } else if (this.fileType === "音频") {
        this.handleAudioUpload(files);
      } else if (this.fileType === "视频") {
        this.handleVideoUpload(files);
      }

      // 清空input值，否则同文件无法重复选择
      this.$refs.fileInput.value = "";
    },
    // 图片上传处理
    handleImageUpload(files) {
      const formData = new FormData();
      formData.append("uuid", localStorage.getItem("uuid") || "");
      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log("response.data.urls", res);

          if (res.data.code === 200) {
            if (this.fileType === "单张图片") {
              this.moduleList[this.selectIndex].moduleContent.urls.push({
                url: res.data.urls,
              });
            } else if (this.fileType === "多张图片") {
              const images = res.data.urls.split(",");
              for (let i = 0; i < images.length; i++) {
                this.moduleList[this.selectIndex].moduleContent.urls.push({
                  url: images[i],
                });
              }
            } else {
              this.moduleList[this.selectIndex].moduleContent.urls.push({
                url: res.data.urls,
              });
            }
            console.log("[][][][][][][][]", this.moduleList);

            this.$message.success("上传成功");
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch((error) => {});
    },
    // 文件上传处理
    handleFileUpload(files) {
      console.log("fejfevfvfvfyufuy12vfyu12vf1y", files[0].name);

      //   const formData = new FormData();
      //   Array.from(files).forEach((file) => {
      //     if (file.size > 10 * 1024 * 1024) {
      //       this.$message.warning("文件大小不能超过10MB");
      //       return;
      //     }
      //     formData.append("file", file);
      //   });

      //   this.uploadFile(formData, "file");

      const formData = new FormData();
      formData.append("uuid", localStorage.getItem("uuid") || "");
      formData.append("file", files[0]);
      //   for (let i = 0; i < files.length; i++) {
      //     formData.append("file", files[i]);
      const fileInfo = {
        name: files[0].name,
        size: files[0].size,
      };

      //   }
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(
            "response.data.urls",
            res.data.code,
            res.data.code === 200,
          );

          if (res.data.code === 200) {
            // console.log("files[0].name", files[0].name);
            this.moduleList[this.selectIndex].moduleContent.files.push({
              name: fileInfo.name,
              url: res.data.urls,
              size: fileInfo.size,
            });
            console.log("[][][][][][][][]=====", this.moduleList);

            this.$message.success("上传成功");
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    // 音频上传处理
    handleAudioUpload(files) {
      const file = files[0];
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning("音频大小不能超过20MB");
        return;
      }

      // 先获取音频时长
      const audio = new Audio(URL.createObjectURL(file));
      audio.onloadedmetadata = () => {
        const duration = Math.ceil(audio.duration);
        // 上传文件
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uuid", localStorage.getItem("uuid") || "");
        axios
          .post(baseURL + "/PCwj/file/uploads", formData, {
            headers: {
              "Content-Type": "multipart/form-data", // 必须设置
              token: localStorage.getItem("token"),
            },
          })
          .then((res) => {
            console.log(
              "response.data.urls",
              res.data.code,
              res.data.code === 200,
            );

            if (res.data.code === 200) {
              // console.log("files[0].name", files[0].name);
              this.moduleList[this.selectIndex].moduleContent.audios.push({
                url: res.data.urls,
                time: duration,
              });
              console.log("[][][][][][][][]=====", this.moduleList);

              this.$message.success("上传成功");
            } else {
              this.$message.error(res.data.msg || "上传失败");
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      };
    },
    handleVideoUpload(files) {
      const file = files[0];
      // 视频大小不能超过50MB
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("视频大小不能超过50MB");
        return;
      }
      // 生成唯一文件名，避免直接修改 File 对象的只读属性
      const timestamp = Date.now();
      const randomStr = Math.random().toString(36).substr(2, 6);
      const fileExtension = file.name.split(".").pop() || "mp4";
      const fileName = `video_${timestamp}_${randomStr}.${fileExtension}`;
      // 创建新的 File 对象
      const newFile = new File([file], fileName, { type: file.type });

      const formData = new FormData();
      // 视频文件名处理,设置为当前时间戳
      // files[0].name = Date.now();
      // 修改文件名
      formData.append("uuid", localStorage.getItem("uuid") || "");
      formData.append("file", newFile);
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(
            "response.data.urls",
            res.data.code,
            res.data.code === 200,
          );

          if (res.data.code === 200) {
            // console.log("files[0].name", files[0].name);
            this.moduleList[this.selectIndex].moduleContent.urls.push({
              url: res.data.urls,
            });
            console.log("[][][][][][][][]=====", this.moduleList);

            this.$message.success("上传成功");
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    // 通用文件上传
    uploadFile(formData, type, duration) {
      // 添加通用参数
      formData.append("uuid", localStorage.getItem("uuid") || "");

      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.$loading().close();
          if (res.code === 200) {
            const urls = res.urls || [];
            console.log("dqwdwqdqwdqw", type);
            if (type === "单张图片") {
              this.moduleList[this.selectIndex].moduleContent.urls.push({
                url: res.urls,
              });
            } else if (type === "多张图片") {
              this.moduleList[this.selectIndex].moduleContent.urls =
                this.moduleList[this.selectIndex].moduleContent.urls.concat(
                  res.urls,
                );
            } else {
              this.moduleList[this.selectIndex].moduleContent.urls = res.urls;
            }
            this.$message.success("上传成功");
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }

          console.log(this.moduleList);
        })
        .catch((err) => {
          this.$loading().close();
          console.error("上传失败：", err);
          this.$message.error("上传失败，请重试");
        });
    },
    // 删除子项
    handleDeleteChildItem(index, subIndex) {
      this.moduleList[index].moduleContent.urls.splice(subIndex, 1);
    },
    // 删除音频
    handleDeleteChildAudio(index, subIndex) {
      // 判断如果是当前播放的音频，直接停止播放
      if (
        this.currentAudio &&
        this.currentAudio.index === index &&
        this.currentAudio.audioIndex === subIndex
      ) {
        if (!this.audioContext.paused) {
          this.audioContext.pause();
        }
        this.currentAudio = null;
      }
      this.moduleList[index].moduleContent.audios.splice(subIndex, 1);
    },
    // 删除文件
    handleDeleteChildFile(index, subIndex) {
      this.moduleList[index].moduleContent.files.splice(subIndex, 1);
    },
    // 清空模块标题
    clearModuleInput(index) {
      this.moduleList[index].moduleContent.context = "";
    },
    // 标题输入限制
    handleInputTitle(e, index) {
      const value = e.target.value;
      if (value.length > 20) {
        this.moduleList[index].moduleContent.context = value.slice(0, 20);
      }
    },
    // 音频播放/暂停
    handleAudioPlay(index, audioIndex) {
      const audioUrl =
        this.moduleList[index].moduleContent.audios[audioIndex].url;

      // 检查是否是当前正在播放的音频
      if (
        this.currentAudio &&
        this.currentAudio.index === index &&
        this.currentAudio.audioIndex === audioIndex &&
        !this.audioContext.paused
      ) {
        // 暂停当前音频
        this.audioContext.pause();
        this.currentAudio = null;
      } else {
        // 停止当前音频（如果有）
        if (!this.audioContext.paused) {
          this.audioContext.pause();
        }
        // 播放新音频
        this.audioContext.src = audioUrl;
        this.audioContext.play();
        // 记录当前播放的音频信息
        this.currentAudio = {
          index: index,
          audioIndex: audioIndex,
          url: audioUrl,
        };
      }
    },
    // 秒转时分秒
    secondsToHms(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return [hours, minutes, secs]
        .map((v) => (v < 10 ? `0${v}` : v))
        .join(":");
    },
    chooseLocation(index) {
      // this.showMapPopup = true;
      this.selectIndex = index;
      this.showMap = true;
    },
    // 确认选择位置的回调
    handleConfirm(location) {
      this.selectedLocation = location;
      console.log("选中的位置：", location);
    },
    // 获取文件图标
    getFileIcon(fileItem) {
      const ext = fileItem.name.split(".").pop().toLowerCase();
      const iconMap = {
        doc: "https://ossfastmake.mustke.com/wenjuan/tupian/PPT 3-1770879824169.svg",
        docx: "https://ossfastmake.mustke.com/wenjuan/tupian/PPT 3-1770879824169.svg",
        xls: "https://ossfastmake.mustke.com/wenjuan/tupian/PPT-1770879864751.svg",
        xlsx: "https://ossfastmake.mustke.com/wenjuan/tupian/PPT-1770879864751.svg",
        pdf: "https://ossfastmake.mustke.com/wenjuan/tupian/PPT 2-1770879892567.svg",
      };
      return (
        iconMap[ext] ||
        "https://ossfastmake.mustke.com/wenjuan/tupian/文档-1769324539165.svg"
      );
    },
    // 图片预览
    showBigImage(url) {
      this.fangdaImgUrl = url;
      this.fangdaShow = true;
    },
    // 封面设置
    handleChooseCover() {
      console.log("feffewfwefwef32232423423");

      // this.fileAccept = "image/*";
      // this.fileMultiple = false;
      // this.$refs.fileInput.click();
      this.showCoverImage = true;
    },
    // 模拟拍照（Web端需借助摄像头API，简化为文件选择）
    chooseImageByCamera() {
      this.handleSingleImage(this.selectIndex);
    },
    // 模拟相册选择
    chooseImageByAlbum() {
      this.handleSingleImage(this.selectIndex);
    },
    handleShowVideoDemo(index) {
      window.open(
        "https://mp.weixin.qq.com/s/B2rHuE5hwLXSAUvtap_wTA",
        "_blank",
      );
    },
    handleShowMiniProgramDemo(index) {
      window.open(
        "https://mp.weixin.qq.com/s/vne1TSEyMHa0LfdqxG9gdw",
        "_blank",
      );
    },
    handleShowOfficialAccount() {
      window.open(
        "https://mp.weixin.qq.com/s/jPP-J4GtwXiH0AyEpMyzxw",
        "_blank",
      );
    },
    handleAddQuestionnaire(index) {
      this.selectIndex = index;
      // const selectedList =
      // 	this.moduleList[index]?.moduleContent?.list || []
      // this.relationalList = this.relationalList.map(item => {
      // 	const checked = selectedList.some(sel => sel.uuid === item.uuid)
      // 	return {
      // 		...item,
      // 		isChecked: checked,
      // 		disabled: !checked && selectedList.length >= 5
      // 	}
      // })
      this.showRelational = true;
    },
    handleDeleteQuestion(index, subIndex) {
      this.moduleList[index].moduleContent.list.splice(subIndex, 1);
    },
    handleSureLink() {
      const selectedList = this.$refs.multipleTable.selection;
      if (selectedList.length === 0) {
        this.$message.warning("请选择要关联的问卷");
        return;
      }
      console.log("ddqwde2e12e12e12e12e", selectedList);

      this.moduleList[this.selectIndex].moduleContent.list = selectedList.map(
        (item) => {
          return {
            name: item.questionnaireName,
            uuid: item.uuid,
            type: item.questionnaireType,
          };
        },
      );

      this.showRelational = false;
    },
    setCoverImageComplete(data) {
      console.log("jugruyegegeqwugeiuqwgwquiew", data);
      this.dataObj.coverUrl = data.coverUrl;
      this.dataObj.ifSyncCoverToShare = data.ifSyncCoverToShare;
      const type = data.coverUrl.split("?")[0].split(".")[
        data.coverUrl.split("?")[0].split(".").length - 1
      ];
      this.mediaType = ["mp4", "avi", "mov"].includes(type) ? "video" : "image";
      if (
        this.dataObj.ifSyncCoverToShare === "1" &&
        this.mediaType === "image"
      ) {
        // 同步封面图到分享
        this.dataObj.shareImgUrl = data.coverUrl;
        this.dataObj.shareImgId = null;
      }
      this.showCoverImage = false;
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.pageNum = page;
      // 这里可以添加获取新页数据的逻辑
      this.getRelationalList();
    },
    handleSelectable(row, index) {
      // console.log("row-1111111111111", row);
      // console.log("index-22222222222", index);
      // if (index === 0) {
      //   return false;
      // } else {
      //   return true;
      // }
      return true;
    },
    handleSearch() {
      this.getRelationalList();
    },
    getData() {
      return this.dataObj;
    },
    // getModuleList() {
    //   return this.moduleList;
    // },
    getModuleList() {
      // 数据校验逻辑（简化版）
      // for (const item of this.moduleList) {
      //   if (!item.moduleContent.context) {
      //     this.$message.warning("请输入模块标题");
      //     return null;
      //   }
      // }
      for (let i = 0; i < this.moduleList.length; i++) {
        const moduleType = this.moduleList[i].moduleType;
        const moduleContent = this.moduleList[i].moduleContent;
        console.log("moduleType8888888888888", moduleType);
        console.log("moduleContent999999999999999", moduleContent);
        if (moduleType === 1) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.urls && moduleContent.urls.length === 0) {
            this.$message.warning("请上传图片");
            return null;
          }
        } else if (moduleType === 2) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.urls.length === 0) {
            this.$message.warning("请上传图片");
            return null;
          }
        } else if (moduleType === 3) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.name === "") {
            this.$message.warning("请选择地址");
            return null;
          }
        } else if (moduleType === 4) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.files.length === 0) {
            this.$message.warning("请上传文件");
            return null;
          }
        } else if (moduleType === 5) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.audios.length === 0) {
            this.$message.warning("请上传音频");
            return null;
          }
        } else if (moduleType === 6) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.urls.length === 0) {
            this.$message.warning("请上传视频");
            return null;
          }
        } else if (moduleType === 7) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.title === "") {
            this.$message.warning("请输入公众号文章标题");
            return null;
          }
          if (moduleContent.link === "") {
            this.$message.warning("请输入公众号文章链接");
            return null;
          }
        } else if (moduleType === 8) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.title === "") {
            this.$message.warning("请输入视频号标题");
            return null;
          }
          if (moduleContent.channelId === "") {
            this.$message.warning("请输入视频号 ID");
            return null;
          }
          if (moduleContent.videoId === "") {
            this.$message.warning("请输入视频 ID");
            return null;
          }
        } else if (moduleType === 9) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.list.length === 0) {
            this.$message.warning("请添加问卷/考试/测评");
            return null;
          }
        } else if (moduleType === 10) {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.title === "") {
            this.$message.warning("请输入小程序展示标题");
            return null;
          }
          if (moduleContent.appId === "") {
            this.$message.warning("请输入小程序APP ID");
            return null;
          }
          if (moduleContent.pagePath === "") {
            this.$message.warning("请输入小程序页面路径");
            return null;
          }
        } else {
          if (moduleContent.context === "") {
            this.$message.warning("请输入模块标题");
            return null;
          }
          if (moduleContent.copyContext === "") {
            this.$message.warning("请输入复制内容");
            return null;
          }
        }
      }
      this.moduleList = this.moduleList.map((item) => ({
        ...item,
        moduleContent: JSON.stringify(item.moduleContent),
      }));
      console.log(this.moduleList, "moduleList000000000000000000");
      return this.moduleList;
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnaire-editor {
  // background-color: #f8f8f8;
  // background-color: #ffffff;
}

.cover-container {
  width: 100%;
  background: #ffffff;
  padding: 15px;
  box-sizing: border-box;
}

.cover-switch-section {
  width: 100%;
  // padding: 0 12.5px 12.5px 12.5px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.switch-label {
  font-weight: 600;
  color: #4c4a56;
  font-size: 15px;
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid rgba(231, 231, 231, 0.5);
}

.switch-label::before {
  display: block;
  content: "";
  width: 4px;
  height: 15px;
  background-color: #3a60ff;
  margin-right: 5px;
}

.cover-image-container {
  width: calc(100%);
  position: relative;
  // padding: 0 12.5px;
  border-radius: 5px;
  margin: 10px auto;
  margin-bottom: 0;
}

.cover-image,
.cover-video {
  width: 100%;
  border-radius: 5px;
}

.change-cover-btn {
  width: 131px;
  //   height: 33px;
  padding: 12px 0;
  font-size: 15px;
  color: #1877ff;
  background: #ffffff;
  border: 1px dashed #1877ff;
  border-radius: 3.5px;
  position: absolute;
  left: 50%;
  bottom: 10%;
  transform: translateX(-50%);
  z-index: 10;
}

.container {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  background-color: #ffffff;
  padding-top: 0;
}

.input-container {
  width: 100%;
  height: 47.5px;
  background: #ffffff;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  padding: 0 12.5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 18px;
  margin-top: 0;
}

.input-content {
  width: 100%;
  border: none;
  outline: none;
  color: #2b2f36;
  font-size: 16px;
}

.other-view .region {
  width: 100%;
  background: #ffffff;
  border: 1px solid #dcdde0;
  margin-top: 7.5px;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 4px;
}

.textarea-content {
  width: 100%;
  border: none;
  outline: none;
  color: #2b2f36;
  font-size: 16px;
  min-height: 80px;
  resize: vertical;
}

.module-item-container {
  background: #ffffff;
  margin-top: 10px;
  padding: 5px 12.5px 12.5px 12.5px;
  box-sizing: border-box;
  border-radius: 4px;
}

.module-header {
  width: 100%;
  display: flex;
  align-items: center;
}

.module-input {
  flex: 1;
  padding: 7.5px 0;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
}

.module-input-content {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
}

.clear-btn1 {
  width: 16px;
  height: 16px;
  margin-left: 5px;
  cursor: pointer;
}

.operate-view {
  display: flex;
}

.operate-view-img {
  width: 24.5px;
  height: 24.5px;
  margin-left: 4px;
  cursor: pointer;
}

.module-item1 {
  margin-top: 12.5px;
}

.image-view {
  width: 100%;
  background: #f4f4f4;
  border-radius: 6.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  // overflow: hidden;
  margin-top: 10px;
}

.image-view .img {
  width: 100%;
  height: auto;
}

.del {
  position: absolute;
  top: -7.5px;
  right: -7.5px;
  width: 20px;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}

.add-url {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12.5px;
  // padding: 10px 0;
  border: 0.5px dashed #3e7bfa;
  width: 165px;
  height: 30px;
  margin-left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}

.plus-icon {
  position: relative;
  width: 10px;
  height: 10px;
}

.plus-icon::before,
.plus-icon::after {
  content: "";
  position: absolute;
  background-color: #1877ff;
}

.plus-icon::before {
  left: 50%;
  top: 0;
  width: 1px;
  height: 100%;
  transform: translateX(-50%);
}

.plus-icon::after {
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  transform: translateY(-50%);
}

.plus-text {
  font-size: 12px;
  font-weight: 400;
  color: #1877ff;
  margin-left: 5px;
}

.module-item2 {
  margin-top: 12.5px;
}

.image-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.small-img-item {
  width: 110px;
  height: 110px;
  position: relative;
}

.small-img {
  width: 110px;
  height: 110px;
  border-radius: 5px;
  object-fit: cover;
  cursor: pointer;
}

.small-img-del {
  width: 20px;
  height: 20px;
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
}

.upload-small {
  width: 110px;
  height: 110px;
  background: #f4f4f4;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px dashed #b2b7bf;
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 400;
    color: #b2b7bf;
    margin-top: 5px;
  }
}

.plus-icon-gray {
  position: relative;
  width: 24px;
  height: 24px;
}

.plus-icon-gray::before,
.plus-icon-gray::after {
  content: "";
  position: absolute;
  background-color: #b2b7bf;
}

.plus-icon-gray::before {
  left: 50%;
  top: 0;
  width: 1px;
  height: 100%;
  transform: translateX(-50%);
}

.plus-icon-gray::after {
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  transform: translateY(-50%);
}

.add-module {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #1877ff;
  border-radius: 5px;
  margin-top: 7.5px;
  background: #fff;
  cursor: pointer;
}

.module-item-img {
  width: 13.5px;
  height: 13.5px;
  margin-right: 7px;
}

.module-item-desc {
  font-size: 15px;
  font-weight: 600;
  color: #1877ff;
}

.module-item3 {
  margin-top: 12.5px;
}

.file-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 12.5px 0;
  background: #f8f8f8;
  border-radius: 3px;
  box-sizing: border-box;
  margin-top: 5px;
}

.file-item .img {
  width: 15px;
  height: 18.5px;
  margin-right: 5px;
  margin-left: 16px;
}

.file-info {
  flex: 1;
  padding: 0 15px 0 10px;
}

.file-name {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  word-break: break-all;
}

.music-view {
  width: 130px;
  height: 38.5px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 19.25px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
  cursor: pointer;
}

.music-image {
  width: 16px;
  height: 20px;
  margin-left: 10.5px;
}

.music-time {
  font-size: 15px;
  font-weight: 600;
  color: #656374;
  margin-left: 14.5px;
}

.video-view {
  position: relative;

  .del {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
    z-index: 10;
  }
}

.module-item4 {
  margin-top: 12.5px;
}

.module-input-view {
  width: 100%;
  margin-top: 10px;
  position: relative;
}

.module-input-label {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 5px;
  display: block;
  text-align: left;
}

.module-input-field {
  width: 100%;
  border-radius: 4px;
  padding: 12.5px;
  box-sizing: border-box;
  background: #f8f8f8;
  display: flex;
  align-items: center;

  .question-name {
    font-size: 14px;
    font-weight: 400;
    color: #676d77;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .copy {
    width: 43px;
    height: 25px;
    background: #ffffff;
    border: 1px solid rgba(24, 119, 255, 0.17);
    border-radius: 22px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: #1877ff;
    line-height: 25px;
  }
}

.topics {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 12.5px 12.5px 12.5px;
  box-sizing: border-box;
}

.topic-item {
  width: calc(100% / 7);
  // height: 54.5px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  // border: 1px solid #3a60ff;
  border-radius: 6.5px;
  // padding: 0 10px;
  box-sizing: border-box;
  margin-top: 10px;
  cursor: pointer;
}

.topic-item-left {
  display: flex;
  align-items: center;
}

.topic-item-context {
  display: flex;
  flex-direction: column;
  margin-left: 10.5px;
}

.topic-item-title {
  font-size: 12px;
  font-weight: 400;
  color: #767d98;
  text-align: left;
  margin-left: 3px;
}

.topic-item-desc {
  font-size: 11px;
  font-weight: 400;
  color: #767d98;
  margin-top: 2px;
}

.demonstrate-view {
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    color: #999999;
    margin-right: 5px;
  }
}

.demonstrate {
  width: 44px;
  height: 16px;
  line-height: 16px;
  background: #9ab3ec;
  border-radius: 8px;
  font-size: 11px;
  color: #ffffff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.setting-icon {
  width: 5px;
  height: 5px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: rotate(-45deg);
  margin-left: 3px;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 500px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  /* overflow-y: auto; */
}

.search-section {
  display: flex;
  align-items: center;
  padding: 0 10px;

  .search-input-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 20px;
    height: 36px;
    border: 1px solid #e8e8e8;
    padding: 0 4px 0 12px;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .search-input {
    flex: 1;
    font-size: 14px;
    color: #333333;
  }

  .search-btn {
    width: 47px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1877ff;
    border-radius: 14px;
    cursor: pointer;
  }
}

.relational-item {
  width: calc(100% - 20px);
  //height: 90rpx;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  font-size: 15px;
  font-weight: 400;
  color: #4c4a56;
  padding: 10px 0 10px 20px;
  box-sizing: border-box;
}

.relational-item-content {
  flex: 1;
  margin-left: 10px;
}

.relational-item-name {
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 21px;
  //  自动换行
  word-break: break-word;
}

.relational-item-time {
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  color: #798497;
  line-height: 17px;
}

.relational-container {
  padding: 10px;
}

.popup-button {
  background-color: #e6ecff;
  color: #3a60ff;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}
</style>

<style scoped>
/* 穿透scoped样式，隐藏表头的全选复选框 */
::v-deep .hide-selection-header .el-checkbox {
  display: none !important;
}

/* 可选：给表头空位置添加占位样式（优化视觉） */
::v-deep .hide-selection-header .cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.demo-page {
  padding: 30px;
}

button {
  padding: 8px 20px;
  background: #2f5597;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.result-box {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e6f7ff;
  border-radius: 4px;
  background: #f0f8ff;
}

.result-box p {
  margin: 5px 0;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/EditHeader/EditHeader.vue